import { Component, computed, inject, input, Signal } from '@angular/core';
import { CountryService } from '../../../../services/country.service';
import { Country } from '@kinomap-dev/ng-ui-lib/core';

@Component({
  selector: 'app-country-cell',
  imports: [],
  template: `<img [src]="flagUrl()" alt="" />{{ country().name }}`,
  styleUrl: './country-cell.scss',
})
export class CountryCell {
  private readonly countryService: CountryService = inject(CountryService);
  readonly country = input.required<Country>();
  readonly flagUrl: Signal<string> = computed(() => {
    return this.country() ? this.countryService.getFlagUrl(this.country().code)() : '';
  });
}
